export default __webpack_public_path__ + "c58193e9c81ce63eacc20e8441d0047c.png";